import React from 'react';
import { motion, useAnimation } from 'framer-motion';
import { Heart } from 'lucide-react';

interface LiveHeartRateProps {
  currentHeartRate: number;
}

export function LiveHeartRate({ currentHeartRate }: LiveHeartRateProps) {
  const controls = useAnimation();

  React.useEffect(() => {
    controls.start({
      scale: [1, 1.2, 1],
      transition: {
        duration: 60 / currentHeartRate,
        repeat: Infinity,
        ease: [0.4, 0, 0.2, 1]
      }
    });
  }, [currentHeartRate, controls]);

  return (
    <div className="theme-card p-4 flex items-center justify-center">
      <motion.div 
        className="relative flex items-center gap-4"
        animate={controls}
      >
        <div className="relative">
          <motion.div
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.5, 1, 0.5]
            }}
            transition={{
              duration: 60 / currentHeartRate,
              repeat: Infinity,
              ease: [0.4, 0, 0.2, 1]
            }}
          >
            <Heart className="w-6 h-6 text-primary" />
            <motion.div 
              className="absolute inset-0 bg-primary/20 rounded-full"
              animate={{
                scale: [1, 2],
                opacity: [0.5, 0]
              }}
              transition={{
                duration: 60 / currentHeartRate,
                repeat: Infinity,
                ease: "easeOut"
              }}
            />
          </motion.div>
        </div>
        <div className="text-4xl font-bold">{currentHeartRate}</div>
        <div className="text-sm text-muted-foreground">BPM</div>
      </motion.div>
    </div>
  );
}